import { FC } from "react";
import { styled } from "@mui/material/styles";
import MuiTextField, { TextFieldProps } from "@mui/material/TextField";

const StyledTextField = styled(MuiTextField)(({ theme }) => ({
  "&.MuiTextField-root": {
    "& .MuiInputLabel-root": {
      color: theme.colors.shades["1000"],
      fontSize: 14,
      fontFamily: theme.fonts.bold,
      textTransform: "uppercase",
      transform: "translate(0,25px) scale(1)",

      "&.MuiInputLabel-shrink": {
        transform: "translate(0,-5px)",
      },
    },

    "& .MuiInput-root": {
      "& .MuiInput-input": {
        color: theme.colors.black,
        fontFamily: theme.fonts.bold,
        fontSize: 18,
        padding: "7px 0 5px",
      },

      "&.MuiInput-underline:before": {
        borderBottom: `1px solid ${theme.colors.shades["600"]}`,

        "&:hover:not(.Mui-disabled, .Mui-error):before": {
          borderWidth: 1,
        },
      },

      "&.MuiInput-underline:after": {
        borderBottom: `2px solid ${theme.colors.navy}`,

        "&:hover:not(.Mui-disabled, .Mui-error):before": {
          borderWidth: 1,
        },
      },
    },
  },
}));

const Button: FC<TextFieldProps> = (props) => {
  return <StyledTextField {...props} />;
};

export default Button;
